// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cc97d848","389":"13859e67","455":"d14ad841","977":"553a8a2f"}[chunkId] + ".chunk.js";
};